import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import AppActions from '../App/actions';
import {deleto, get, puto} from 'bukku/shared/ApiService';
import {t} from "@lingui/macro";

// Read annotation
export function* readAnnotationRequest() {
    yield takeEvery(actions.READ_ANNOTATION_REQUEST, function* (payload, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/annotations', null, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.READ_ANNOTATION_SUCCESS,
                annotation: data.annotation,
            });
        }
        catch (error) {
            yield put({
                type: actions.READ_ANNOTATION_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readAnnotationSuccess() {
    yield takeEvery(actions.READ_ANNOTATION_SUCCESS, () => {});
}
export function* readAnnotationError() {
    yield takeEvery(actions.READ_ANNOTATION_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Update annotation
export function* updateAnnotationRequest() {
    yield takeEvery(actions.UPDATE_ANNOTATION_REQUEST, function* ({ id, request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(puto, `/annotations/${id}`, request, context);

            // OK
            yield put({
                type: actions.UPDATE_ANNOTATION_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.UPDATE_ANNOTATION_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* updateAnnotationSuccess() {
    yield takeEvery(actions.UPDATE_ANNOTATION_SUCCESS, function* () {
        yield message.success(t`The annotation is saved.`);
    });
}
export function* updateAnnotationError() {
    yield takeEvery(actions.UPDATE_ANNOTATION_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Delete annotation
export function* deleteAnnotationRequest() {
    yield takeEvery(actions.DELETE_ANNOTATION_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(deleto, `/annotations/${id}`, null, context);

            // OK
            yield put({
                type: actions.DELETE_ANNOTATION_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.DELETE_ANNOTATION_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* deleteAnnotationSuccess() {
    yield takeEvery(actions.DELETE_ANNOTATION_SUCCESS, function* () {
        yield message.success(t`The annotation is deleted.`);
    });
}
export function* deleteAnnotationError() {
    yield takeEvery(actions.DELETE_ANNOTATION_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export default function* rootSaga() {
    yield all([
        fork(readAnnotationRequest),
        fork(readAnnotationSuccess),
        fork(readAnnotationError),
        fork(updateAnnotationRequest),
        fork(updateAnnotationSuccess),
        fork(updateAnnotationError),
        fork(deleteAnnotationRequest),
        fork(deleteAnnotationSuccess),
        fork(deleteAnnotationError),
    ]);
}
